<template>
    <div class="row " style="min-width: 1200px; min-height: 100%; overflow: auto;">
        <div class="card q-pa-md">
            <div class="drawerButtons" style="right: 0px; position:absolute; margin-top: -10px;">
                <q-btn @click="$emit('closeDialog',true)" flat icon="close" round size="small"></q-btn>
            </div>
            <div class="row">
                <div class="d-flex col-12 q-pa-md pt-0"
                     style="justify-content: space-between; align-items: center ">
                    <q-dialog position="right" v-model="dialog">
                        <q-card style="min-width: 1000px !important; min-height: 800px;">
                            <q-card-section>
                                <div class="row">
                                    <div class="d-flex col-12 q-pa-md pt-0"
                                         style="justify-content: space-between; align-items: center ">
                                        <div>
                                            <h4 style="font-size: 22px; font-weight: 300;">
                                                Transfer Details
                                            </h4>
                                        </div>
                                        <div class="drawerButtons" style="margin-top: -10px;">
                                            <q-btn @click="dialog=false" flat icon="close" round size="small"></q-btn>
                                        </div>
                                    </div>

                                    <div class="col-4 q-pa-md" style="border-right: 1px solid lightgray">
                                        <ul style="list-style: none">
                                            <li class="pb-3" style="border-bottom: 1px solid #e0e0e0">
                                                <span class="bankLabel d-block">Order ID</span>
                                                <h4 style="font-size: 24px; font-weight: 400">
                                                    {{selectedOrderObj.orderNum?selectedOrderObj.orderNum:'-'}}</h4>
                                            </li>
                                            <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                                <span class="bankLabel d-block">Partner Type</span>
                                                <span>{{selectedOrderObj.orderType=='2'?'Retail Sales':(selectedOrderObj.OrderItems&&selectedOrderObj.OrderItems.length&&selectedOrderObj.OrderItems[0].ToOrganization?selectedOrderObj.OrderItems[0].ToOrganization.PartnerType.prefix:'-')}}</span>
                                            </li>
                                            <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                                <span class="bankLabel d-block">Order From</span>
                                                <span>{{selectedOrderObj.OrderItems&&selectedOrderObj.OrderItems.length&&selectedOrderObj.OrderItems[0].FromOrganization?selectedOrderObj.OrderItems[0].FromOrganization.name:'-'}}</span>
                                            </li>
                                            <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                                <span class="bankLabel d-block">Order To</span>
                                                <span>{{selectedOrderObj.orderType=='2'?(selectedOrderObj.OrderItems&&selectedOrderObj.OrderItems.length&&selectedOrderObj.OrderItems[0].ToCustomer?selectedOrderObj.OrderItems[0].ToCustomer.name:'-'):(selectedOrderObj.OrderItems&&selectedOrderObj.OrderItems.length&&selectedOrderObj.OrderItems[0].ToOrganization?selectedOrderObj.OrderItems[0].ToOrganization.name:'-')}}</span>
                                            </li>
                                            <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                                <span class="bankLabel d-block">Order Date</span>
                                                <span>{{selectedOrderObj.date?dateFilter(selectedOrderObj.date):'-'}}</span>
                                            </li>
                                            <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                                <span class="bankLabel d-block">Created on</span>
                                                <span>{{selectedOrderObj.createdOn?dateTimeFilter(selectedOrderObj.createdOn):'-'}}</span>
                                            </li>
                                            <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                                <span class="bankLabel d-block">Invoice No</span>
                                                <span>{{selectedOrderObj.invoiceNumber?selectedOrderObj.invoiceNumber:'-'}}</span>
                                            </li>
                                            <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                                <span class="bankLabel d-block">Invoice Date</span>
                                                <span>{{selectedOrderObj.invoiceDate?dateFilter(selectedOrderObj.invoiceDate):'-'}}</span>
                                            </li>
                                            <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                                <span class="bankLabel d-block">Invoice Note</span>
                                                <span>{{selectedOrderObj.invoiceNote?selectedOrderObj.invoiceNote:'-'}}</span>
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="col-8 q-pa-md" style="height: 80vh; overflow-y: auto">
                                        <h6 style="margin-top: -18px;margin-bottom: 10px;">Total Items :
                                            {{selectedOrderObj.totalBatchcount}}</h6>
                                        <q-list bordered class="rounded-borders">
                                            <template v-for="(product, index) in selectedOrderObj.productArr">
                                                <q-expansion-item>
                                                    <template slot="header">
                                                        <q-item-section>
                                                            {{product.productName}}
                                                            <!--      ({{product.productLineName}}-{{product.OemName}})  -->
                                                        </q-item-section>
                                                        <q-item-section side>{{product.batchArr.length}}
                                                        </q-item-section>
                                                    </template>

                                                    <q-card>
                                                        <q-card-section>
                                                            <q-list bordered padding>
                                                                <q-item :key="i" tag="label"
                                                                        v-for="(batch, i) in product.batchArr">
                                                                    <q-item-section side top>
                                                                        <!--<q-checkbox v-model="batch.batchChecked"></q-checkbox>-->
                                                                    </q-item-section>

                                                                    <q-item-section>
                                                                        <q-item-label>{{batch.batch}}
                                                                            <span style="float:right;">
                                                   <!--{{batch.orderItemStatus}}-->
                                                </span>
                                                                        </q-item-label>
                                                                        <q-item-label caption>
                                                                            {{product.productLineCode}}
                                                                        </q-item-label>
                                                                    </q-item-section>
                                                                </q-item>
                                                            </q-list>
                                                        </q-card-section>
                                                    </q-card>
                                                </q-expansion-item>
                                            </template>
                                        </q-list>
                                    </div>
                                </div>
                            </q-card-section>

                        </q-card>
                    </q-dialog>
                    <div class="app-fixed-header"
                         style="width: 1200px; left: unset; top: 25px !important; right: 0px !important;">
                        <div class="d-flex justify-content-between w-100" style="align-items: center; height: 60px;">
                            <h4 style="font-size: 26px; font-weight: 300; margin-left: 25px; ">Transfer History</h4>
                            <div class="d-flex" style="justify-content: space-between">
                                <q-btn class="mr-5" color="blue" @click="exportTransferHistory">Export</q-btn>
                                <q-btn @click="$emit('closeDialog',true)" flat icon="close" round size="small"></q-btn>
                            </div>
                        </div>
                    </div>


                    <q-timeline color="blue-10" style="font-size: 16px !important; margin-top: 50px;">
                        <template v-for="(order, index) in ordersArr">
                            <q-timeline-entry>
                                <q-card @click="openOrderDetail(order)" class="product-card">
                                    <q-card-section>
                                        <div class="mp-card row">
                                            <div class="col-8">
                                                <div class="mp-header pr-3">
                                                    <div class="d-flex justify-content-between"
                                                         style=" align-items: center">
                                                        <div class="d-flex">
                                                            <div class="text-left">
                                                                <span class="bankLabel ">Order ID</span>
                                                                <h6>
                                                                    {{order.Order.orderNum?order.Order.orderNum:'-'}}
                                                                </h6>
                                                            </div>

                                                        </div>
                                                        <div class="d-flex ">
                                                            <q-chip class="custom-chip" color="primary" icon="person"
                                                                    outline text-color="white">
                                                                {{order.Order.orderType==2?'Retail Sales':(order.Order.OrderItems&&order.Order.OrderItems.length&&order.Order.OrderItems[0].ToOrganization?order.Order.OrderItems[0].ToOrganization.PartnerType.prefix:'-')}}
                                                            </q-chip>
                                                            <q-chip class="custom-chip" color="primary" icon="payment"
                                                                    outline text-color="white">
                                                                {{order.Order.status?order.Order.status:'-'}}
                                                            </q-chip>
                                                            <q-chip class="custom-chip" color="primary" outline>
                                                                {{order.Order.totalBatchcount}}
                                                                {{order.Order.totalBatchcount>1?'Items':'Item'}}
                                                            </q-chip>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr class="my-2 mr-3" style="border: 0.5px solid lightgray">
                                                <div class="mp-body ">
                                                    <div class="row">
                                                        <div class="col-4">
                                                            <div class="text-left">
                                                                <span class="bankLabel text-left">Order From</span>
                                                                <div class="mp-value text-left">
                                                                    <span class="text-left">{{order.Order.OrderItems&&order.Order.OrderItems.length&&order.Order.OrderItems[0].FromOrganization?order.Order.OrderItems[0].FromOrganization.name:'-'}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-4 d-flex" style="align-items: center">
                                                            <div class="text-left">
                                                                <img alt=""
                                                                     src="../../assets/point_line.png" style="width: 50%;">
                                                            </div>
                                                        </div>
                                                        <div class="col-4">
                                                            <div class="text-left">
                                                                <span class="bankLabel text-left">Order To</span>
                                                                <div class="mp-value text-left">
                                                                    <span class="text-left">
                                                                        {{order.Order.orderType==2?(order.Order.OrderItems&&order.Order.OrderItems.length&&order.Order.OrderItems[0].ToCustomer?order.Order.OrderItems[0].ToCustomer.name:'-'):(order.Order.OrderItems&&order.Order.OrderItems.length&&order.Order.OrderItems[0].ToOrganization?order.Order.OrderItems[0].ToOrganization.name:'-')}}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-3 mt-3">
                                                            <div class="text-left">
                                                                <span class="bankLabel text-left">Order Date</span>
                                                                <div class="mp-value text-left">
                                                                    <span>{{order.Order.date?dateFilter(order.Order.date):'-'}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-3 mt-3">
                                                            <div class="text-left">
                                                                <span class="bankLabel text-left">Invoice Number</span>
                                                                <div class="d-flex ">
                                                                    <div class="mp-value text-left">
                                                                        <span class="text-left">{{order.Order.invoiceNumber?order.Order.invoiceNumber:'-'}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-3 mt-3">
                                                            <div class="text-left">
                                                                <span class="bankLabel text-left">Created On</span>
                                                                <div class="mp-value text-left">
                                                                    <span class="text-left">{{order.Order.createdOn?dateTimeFilter(order.Order.createdOn):'-'}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-3 mt-3">
                                                            <div class="text-left">
                                                                <span class="bankLabel text-left">Invoice Date</span>
                                                                <div class="d-flex ">
                                                                    <div class="mp-value text-left">
                                                                        <span class="text-left">{{order.Order.invoiceDate?dateFilter(order.Order.invoiceDate):'-'}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <ul>
                                                        <div class=""
                                                             style="align-items: center">
                                                            <ul class="d-flex">

                                                            </ul>
                                                        </div>
                                                    </ul>

                                                </div>
                                            </div>

                                            <div class="col-4 q-pa-md" style="border-left: 1px solid lightgrey;">
                                                <div class="text-left mp-value d-flex justify-content-between mb-3">
                                                    <span style="color: #000;">Transfer Points</span>
                                                    <h6 style="color: #191919;">
                                                        {{order.transferPoint?order.transferPoint:'-'}}
                                                    </h6>
                                                </div>
                                                <!--
                                                <div class="text-left mp-value d-flex justify-content-between my-3"
                                                     v-if="order.boosterPoint">
                                                    <span class="bankLabel">Booster Points</span>
                                                    <h6 style="color: #191919;">
                                                        {{order.eligiblePoint?order.boosterPoint:'-'}}
                                                    </h6>
                                                </div>

                                                <div class="text-left mp-value d-flex justify-content-between my-3"
                                                     v-if="order.Order && order.Order.Adjustment">
                                                    <span class="bankLabel">Additional Points</span>
                                                    <h6 style="color: #191919;">
                                                        {{order.Order &&
                                                        order.Order.Adjustment?order.Order.Adjustment.additionalPoint:'-'}}
                                                    </h6>
                                                </div>
                                                <hr class="my-2" style="border: 0.5px dashed lightgray">
                                                <div class="text-left mp-value d-flex justify-content-between my-3"
                                                     v-if="order.boosterPoint || (order.Order && order.Order.Adjustment)">
                                                    <span class="bankLabel">Total Points</span>
                                                    <h6 style="color: #191919;">
                                                        {{calculateTotalPointsInHistory(order)}}
                                                    </h6>
                                                </div>
                                                <div v-if="!isSpecialScheme">
                                                    <div class="text-center mp-value mt-5">
                                                        <a @click.stop="startAddingExtraPoint(order)"
                                                           class="text-center"
                                                           style="color: #0f5992">{{order.Order &&
                                                            order.Order.Adjustment?'Edit':'Add'}}
                                                            Additional Points</a>
                                                    </div>
                                                </div> -->
                                            </div>
                                        </div>
                                    </q-card-section>
                                </q-card>
                            </q-timeline-entry>
                        </template>
                    </q-timeline>


                </div>
            </div>
            <div class="text-center" v-if="!ordersArr.length">
                <div class="d-block mx-auto w-50">
                    <img alt="" class="w-100 d-block mx-auto" src="../../assets/no_Data.png">
                </div>
                <h6>No order history available</h6>
            </div>
        </div>
    </div>
</template>

<script>
import {GET_TRANSFER_POINT_HISTORY} from '../../graphql/queries/schemePoints'
import {SUBSCRIBE_TRANSFER_POINT_HISTORY} from '../../graphql/subscription/schemePoints'
import moment from 'moment'
import Constants from '../../Constants/Constant'
import axios from 'axios'

export default {
    name: 'TransferHistory',
    props: ['partnerId', 'schemeId', 'startDate', 'endDate', 'isSpecialScheme'],
    data () {
        return {
            userObj: JSON.parse(localStorage.getItem('currentPartner')),
            user: JSON.parse(localStorage.getItem('user')),
            ordersArr: [],
            temp_ordersArr: [],
            dialog: false,
            selectedOrderObj: '',
            currentOrder: null
        }
    },
    apollo: {
        SchemePointsHistoryOrderWise: {
            query: GET_TRANSFER_POINT_HISTORY,
            fetchPolicy: 'network-only',
            skip () {return !this.startDate},
            variables () {
                return {
                    partnerId: this.partnerId,
                    schemeId: this.schemeId,
                    startDate: moment(this.startDate, 'YYYY-MM-DD').startOf('day').format(),
                    endDate: moment(this.endDate, 'YYYY-MM-DD').endOf('day').format(),
                }
            },
            subscribeToMore: {
                document: SUBSCRIBE_TRANSFER_POINT_HISTORY,
                skip () {return !this.startDate},
                variables () {
                    return {
                        partnerId: this.partnerId,
                        schemeId: this.schemeId,
                        startDate: moment(this.startDate, 'YYYY-MM-DD').startOf('day').format(),
                        endDate: moment(this.endDate, 'YYYY-MM-DD').endOf('day').format(),
                    }
                },
                updateQuery: function (previousQueryResult, { subscriptionData }) {
                    this.groupOrderItemsByProductId(subscriptionData.data.SchemePointsHistoryOrderWise)
                },
            },
            result ({ data, loading }) {
                if (!loading) {
                    this.groupOrderItemsByProductId(data.SchemePointsHistoryOrderWise)
                }
            },
        },
    },
    methods: {
        dateFilter (val) {return val ? moment(val).format('DD/MM/YYYY') : '-'},
        groupOrderItemsByProductId (orders) {
            this.ordersArr = []

            orders.forEach(function (ord) {
                let order = ord.Order
                order.productArr = []
                order.totalBatchcount = order.OrderItems.length
                order.OrderItems.forEach(function (curnt) {
                    if (!Constants.containsObject({ productId: curnt.Batch.productId }, order.productArr)) {
                        order.productArr.push({ productId: curnt.Batch.productId })
                    }
                })
                order.productArr.forEach(function (product) {
                    product.batchArr = []
                    order.OrderItems.forEach(function (curnt) {
                        if (product.productId == curnt.Batch.productId) {
                            curnt.Batch.orderItemId = curnt.orderItemId
                            curnt.Batch.orderItemStatus = curnt.orderItemStatus
                            product.batchArr.push(curnt.Batch)
                            if (curnt.Product) {
                                product.productName = curnt.Product.name
                                product.productLineName = curnt.Product.ProductLine.name
                                product.OemName = curnt.Product.OEM.name
                                product.productLineCode = curnt.Product.productLineCode
                            }
                        }
                    })
                })
            })
            this.ordersArr = orders
            this.temp_ordersArr = JSON.parse(JSON.stringify(orders))
        },
        openOrderDetail (order) {
            this.selectedOrderObj = order.Order
            this.dialog = true
        },
        async exportTransferHistory(){
            let request = {
                orderId: this.ordersArr.map(o => o.Order.id),
                partnerId: this.partnerId,
                schemeId: this.schemeId
            };
            let response = await axios({
                method: 'POST', url: `${Constants.api_url}exportSchemeTransferPointHistory`,
                data: request, responseType: 'blob'
            });
            const a = window.document.createElement('a');
            a.href = window.URL.createObjectURL(response.data);
            a.download = 'SchemeTransferPointHistory_' + moment().format('DD/MM/YYYY HH:mm') + '.xlsx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
    },
}
</script>

<style scoped>
    .card {
        text-align: center;
        width: 100%;
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: bottom;
        border-radius: 4px;
        box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
        position: relative;
    }

    /deep/ .q-timeline__content {
        padding-bottom: 0px !important;
    }


</style>

